import { SbCurrentUser } from "../submission_boards/component/SbModel";

export const SubscriptionTier = {
  free: 'free',
  pro: 'pro',
  pro_idle: 'pro_idle',
  premium: 'premium',
  archive: 'archive',
  enterprise: 'enterprise',
};
export const BillingCycle = {
  month: 'month',
  year: 'year'
};

'month'
export interface UserPlan {
  user_id: number;
  start_date: Date;
  end_date: Date;
  status: number;
  stripe_product_id: string;
  stripe_subscription_id?: string;
}

// Define the structure for a plan
export interface MasterPlan {
  stripe_url: string;
  stripe_product_id: string;
  subscription_tier: string;
  plan_name: string;
  description: string;
  amount: string;
  billing_cycle: string;
  plan_tag: string;
  is_visible: number;
}


  export const isDownGradeUserPlan = (user_subscription_tier: string, for_subscription_tier: string, ) => {
    switch (user_subscription_tier) {
        case SubscriptionTier.free:
            
            break;
        case SubscriptionTier.pro:
            if(for_subscription_tier ==SubscriptionTier.free ||
                for_subscription_tier ==SubscriptionTier.archive
            )
            {
                return true;
            }
            break;
        case SubscriptionTier.pro_idle:
            if(for_subscription_tier ==SubscriptionTier.free ||
                for_subscription_tier ==SubscriptionTier.pro ||
                for_subscription_tier ==SubscriptionTier.archive
            )
            {
                return true;
            }
            break;
        case SubscriptionTier.premium:
            if(for_subscription_tier ==SubscriptionTier.free ||
                for_subscription_tier ==SubscriptionTier.pro ||
                for_subscription_tier ==SubscriptionTier.archive
            )
            {
                return true;
            }
            break;
        case SubscriptionTier.archive:
            if(for_subscription_tier ==SubscriptionTier.free
            )
            {
                return true;
            }
            break;
    
        default:
            break;
    }
    return false;
    
  }